"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const DEFAULT_ENDPOINT = 'https://ens.buidlhub.com';

class BuidlhubEnsClient {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const endpoint = props.endpoint || DEFAULT_ENDPOINT;
    this.endpoint = endpoint;
  }

  async addSubscription() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this._validatePropsExist(props, ['emailAddress', 'publicAddress']);

    const {
      publicAddress,
      emailAddress,
      language
    } = props;
    return this._post('/register', {
      walletAddress: publicAddress,
      email: emailAddress,
      language
    });
  }

  async getSubscription() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this._validatePropsExist(props, ['publicAddress']);

    const {
      publicAddress,
      language
    } = props;
    return this._post('/lookupRegistration', {
      walletAddress: publicAddress,
      language
    });
  }

  _validatePropsExist(props, requiredProps) {
    for (const propertyName of requiredProps) {
      const propertyValue = props[propertyName];

      if (!propertyValue) {
        throw new Error("".concat(propertyName, " is required"));
      }
    }
  }

  async _post(resourcePath, body) {
    var _window, _window$location;

    const url = this.endpoint + resourcePath;
    const options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'x-referrer': (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname
      },
      body: JSON.stringify(body)
    };
    const response = await this._fetchWithRetry(url, options);
    const data = response.json();

    if (data.error) {
      throw new Error(data.error);
    }

    return data;
  }

  async _fetchWithRetry(url, options) {
    let maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    let lastError = null;

    for (let i = 0; i < maxAttempts; i++) {
      try {
        return await fetch(url, options);
      } catch (error) {
        lastError = error;
      } // sleep before retry


      await new Promise(resolve => setTimeout(resolve, 250));
    }

    throw lastError;
  }

}

exports.default = BuidlhubEnsClient;